module.exports = __webpack_public_path__ + "img/instagram.2fa21f6f.svg";